/* eslint-disable no-param-reassign */
import { applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import initialReducers from '../reducers';

import { getStore, initStore } from './helpers';

function createReducerManager(reducers) {
  // Create the initial combinedReducer
  let combinedReducer = combineReducers(reducers);

  const rootReducer = (state, action) => {
    // set initial values on user log out
    if (action.type === 'app/USER_LOGOUT') {
      state = undefined;
    }

    return combinedReducer(state, action);
  };
  // An array which is used to delete state keys when reducers are removed
  let keysToRemove = [];

  return {
    getReducerMap: () => reducers,
    // The root reducer function exposed by this object
    // This will be passed to the store
    reduce: (state, action) => {
      // If any reducers have been removed, clean up their state first
      if (keysToRemove.length > 0) {
        state = { ...state };

        for (const key of keysToRemove) {
          delete state[key];
        }

        keysToRemove = [];
      }

      // Delegate to the combined reducer
      return rootReducer(state, action);
    },
    // Adds a new reducer with the specified key
    add: (key, reducer) => {
      if (!key || reducers[key]) {
        return;
      }

      // Add the reducer to the reducer mapping
      reducers[key] = reducer;
      // Generate a new combined reducer
      combinedReducer = combineReducers(reducers);

      // eslint-disable-next-line consistent-return
      return combinedReducer;
    },
    // Removes a reducer with the specified key
    remove: (key) => {
      if (!key || !reducers[key]) {
        return;
      }

      // Remove it from the reducer mapping
      delete reducers[key];
      // Add the key to the list of keys to clean up
      keysToRemove.push(key);
      // Generate a new combined reducer
      combinedReducer = combineReducers(reducers);
    },
  };
}

export function configureStore() {
  const reducerManager = createReducerManager(initialReducers);

  const middlewares = [thunkMiddleware];
  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  );

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  initStore({ reducerManager, composedEnhancers });

  return getStore();
}
